// Tabs del editor de un visual. Primera pestaña según el modo:
//  - declarativo: render_config (JSON)
//  - custom:      Código (JS)  — la función real del componente
// Deliberadamente "tonto": solo presenta; el estado vive en el modal padre.
import React, { useState, useEffect } from 'react';

export default function VisualEditorTabs({
  editorMode = 'declarative',
  renderConfig, onRenderConfigChange, jsonError,
  code, onCodeChange, codeError,
  dataSql, onDataSqlChange, preview, toolbar, sqlToolbar,
}) {
  const [tab, setTab] = useState('main'); // 'main' | 'sql' | 'preview'
  const isCustom = editorMode === 'custom';
  // Al cambiar de modo (Declarativo ↔ Código), volver a la pestaña del editor.
  useEffect(() => { setTab('main'); }, [editorMode]);

  return (
    <div className="vz-tabs">
      <div className="vz-tabs-head">
        <button className={tab === 'main' ? 'active' : ''} onClick={() => setTab('main')}>
          {isCustom ? 'Código (JS)' : 'render_config (JSON)'}
        </button>
        <button className={tab === 'sql' ? 'active' : ''} onClick={() => setTab('sql')}>data_sql (SQL)</button>
        <button className={tab === 'preview' ? 'active' : ''} onClick={() => setTab('preview')}>Preview</button>
      </div>
      <div className="vz-tabs-body">
        {tab === 'main' && (
          <div className="vz-tab-render">
            {toolbar && <div className="vz-tab-toolbar">{toolbar}</div>}
            {isCustom ? (
              <>
                <textarea
                  className="vz-code" rows={18} value={code} spellCheck={false}
                  onChange={(e) => onCodeChange(e.target.value)}
                />
                {codeError
                  ? <div className="vz-error">Código: {codeError}</div>
                  : <div className="vz-hint">La función <code>(data, theme, helpers) =&gt; option</code> construye la gráfica. <code>data</code> trae el payload completo; <code>helpers</code> expone los builders (<code>buildMultiLineChart</code>…), <code>deepMerge</code>, <code>formatValue</code>, <code>axisFormatter</code>, paletas. Se compila en el navegador (admin-only).</div>}
              </>
            ) : (
              <>
                <textarea
                  className="vz-code" rows={16} value={renderConfig} spellCheck={false}
                  onChange={(e) => onRenderConfigChange(e.target.value)}
                />
                {jsonError
                  ? <div className="vz-error">JSON inválido: {jsonError}</div>
                  : <div className="vz-hint">Cómo se construye la gráfica. La <code>option</code> base se arma de <code>source+chart+encoding</code>; lo que pongas en <code>option</code> se deep-mergea encima (los arrays se reemplazan).</div>}
              </>
            )}
          </div>
        )}
        {tab === 'sql' && (
          <div className="vz-tab-sql">
            {sqlToolbar && <div className="vz-tab-toolbar">{sqlToolbar}</div>}
            <textarea
              className="vz-code" rows={16} value={dataSql} spellCheck={false}
              placeholder="SELECT ... (Athena)"
              onChange={(e) => onDataSqlChange(e.target.value)}
            />
            <div className="vz-hint">Cómo se jalan los datos de este widget (Athena). <strong>Probar SQL</strong> lo ejecuta y alimenta el Preview; al guardar, usa <strong>Materializar</strong> para fijar el resultado en el tablero. Si está vacío, el widget usa el payload compartido del demo.</div>
          </div>
        )}
        {tab === 'preview' && <div className="vz-tab-preview">{preview}</div>}
      </div>
    </div>
  );
}
